<div mat-dialog-title>Тип столешницы</div>
<div mat-dialog-content>
  <div class="flex flex-col gap-4">
    <div class="text-lg" i18n>Простая</div>

    <div class="flex flex-row space-x-1">
      <csl-item-card
        data-testid="simple"
        #simple
        (click)="selectSimpleType(); selected = simple"
        [class.bg-[#039be521]]="selected === simple"
        class="p-2 cursor-pointer"
        [disabled]="disabled"
        [iconLink]="'assets/images/countertop-types/simple.svg'">
      </csl-item-card>
    </div>

    <div class="text-lg" i18n>Г-образная</div>

    <div class="flex flex-row space-x-1">
      <csl-item-card
        data-testid="fullLengthTopWithRightSide"
        #fullLengthTopWithRightSide
        (click)="selectGShapedType(gShapedTypes.FullLengthTopWithRightSide); selected = fullLengthTopWithRightSide"
        [class.bg-[#039be521]]="selected === fullLengthTopWithRightSide"
        class="p-2 cursor-pointer"
        [disabled]="disabled"
        [iconLink]="'assets/images/countertop-types/gShapedFullLengthTopWithRightSide.svg'">
      </csl-item-card>
      <csl-item-card
        data-testid="fullLengthTopWithLeftSide"
        #fullLengthTopWithLeftSide
        (click)="selectGShapedType(gShapedTypes.FullLengthTopWithLeftSide); selected = fullLengthTopWithLeftSide"
        [class.bg-[#039be521]]="selected === fullLengthTopWithLeftSide"
        class="p-2 cursor-pointer"
        [disabled]="disabled"
        [iconLink]="'assets/images/countertop-types/gShapedFullLengthTopWithLeftSide.svg'">
      </csl-item-card>
      <csl-item-card
        data-testid="withFullWidthRightSide"
        #withFullWidthRightSide
        (click)="selectGShapedType(gShapedTypes.WithFullWidthRightSide); selected = withFullWidthRightSide"
        [class.bg-[#039be521]]="selected === withFullWidthRightSide"
        class="p-2 cursor-pointer"
        [disabled]="disabled"
        [iconLink]="'assets/images/countertop-types/gShapedWithFullWidthRightSide.svg'">
      </csl-item-card>
      <csl-item-card
        data-testid="withFullWidthLeftSide"
        #withFullWidthLeftSide
        (click)="selectGShapedType(gShapedTypes.WithFullWidthLeftSide); selected = withFullWidthLeftSide"
        [class.bg-[#039be521]]="selected === withFullWidthLeftSide"
        class="p-2 cursor-pointer"
        [disabled]="disabled"
        [iconLink]="'assets/images/countertop-types/gShapedWithFullWidthLeftSide.svg'">
      </csl-item-card>
    </div>

    <div class="text-lg" i18n>П-образная</div>

    <div class="flex flex-row space-x-1">
      <csl-item-card
        data-testid="fullLengthTop"
        #fullLengthTop
        (click)="selectPShapedType(pShapedTypes.FullLengthTop); selected = fullLengthTop"
        [class.bg-[#039be521]]="selected === fullLengthTop"
        class="p-2 cursor-pointer"
        [disabled]="disabled"
        [iconLink]="'assets/images/countertop-types/pShapedFullLengthTop.svg'">
      </csl-item-card>
      <csl-item-card
        data-testid="withFullWidthSides"
        #withFullWidthSides
        (click)="selectPShapedType(pShapedTypes.WithFullWidthSides); selected = withFullWidthSides"
        [class.bg-[#039be521]]="selected === withFullWidthSides"
        class="p-2 cursor-pointer"
        [disabled]="disabled"
        [iconLink]="'assets/images/countertop-types/pShapedWithFullWidthSides.svg'">
      </csl-item-card>
      <csl-item-card
        data-testid="pShapedWithFullWidthLeftSide"
        #pShapedWithFullWidthLeftSide
        (click)="selectPShapedType(pShapedTypes.WithFullWidthLeftSide); selected = pShapedWithFullWidthLeftSide"
        [class.bg-[#039be521]]="selected === pShapedWithFullWidthLeftSide"
        class="p-2 cursor-pointer"
        [disabled]="disabled"
        [iconLink]="'assets/images/countertop-types/pShapedWithFullWidthLeftSide.svg'">
      </csl-item-card>
      <csl-item-card
        data-testid="pShapedWithFullWidthRightSide"
        #pShapedWithFullWidthRightSide
        (click)="selectPShapedType(pShapedTypes.WithFullWidthRightSide); selected = pShapedWithFullWidthRightSide"
        [class.bg-[#039be521]]="selected === pShapedWithFullWidthRightSide"
        class="p-2 cursor-pointer"
        [disabled]="disabled"
        [iconLink]="'assets/images/countertop-types/pShapedWithFullWidthRightSide.svg'">
      </csl-item-card>
    </div>
  </div>
</div>
<div mat-dialog-actions>
  <button i18n mat-raised-button color="accent" [disabled]="!countertop" data-testid="countertopTypeSelectOk" [mat-dialog-close]="countertop">ОК</button>
  <button i18n mat-button [mat-dialog-close]>ОТМЕНА</button>
</div>
